import { Controller } from "@hotwired/stimulus"

// Scrolls to a target element when a turbo frame loads
export default class extends Controller {
  static values = {
    target: String,
    offset: { type: Number, default: 80 } // Offset for fixed headers
  }

  connect() {
    // Listen for turbo frame loads
    this.element.addEventListener('turbo:frame-load', this.scrollToTarget.bind(this))
  }

  scrollToTarget(event) {
    const targetId = this.targetValue
    if (!targetId) return

    const targetElement = document.getElementById(targetId)
    if (!targetElement) return

    // Small delay to ensure content is rendered
    setTimeout(() => {
      const elementPosition = targetElement.getBoundingClientRect().top
      const offsetPosition = elementPosition + window.pageYOffset - this.offsetValue

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      })
    }, 50)
  }
}

